import gql from "graphql-tag";

const FlightScheduleImport = gql`
  query FlightScheduleImport($id: ID!) {
    flightScheduleImport(id: $id) {
      filename
      executionStatus
      executionLogs
      createdAt
      updatedAt
      id
    }
  }
`;

export { FlightScheduleImport };



// WEBPACK FOOTER //
// ./src/queries/FlightScheduleImport.js